import { COUNTRY, GLOBAL_STATE_NAME } from '../../../utils/constants'
import { loadValue, saveValue } from '../../../utils/localStorage'
import { getSettingsState } from '../store/slices/selectors'
import { APPLICATION_TYPES, APP_STATE_KEY, ROOF_MEMBER_TYPES } from './constants'
import OUTPUT_HELPER_DATA from './json/OUTPUT_HELPER_DATA.json'
import { roofWidthOptions } from './json/carrying-member.json'
import { defaultValues } from './json/common.json'

export const isOneDropdownOption = (options) => options.length <= 1
// returns a function which concatenate all the given classes
export const concatClasses = (...args) => {
  return args.reduce((acc, className) => (className ? `${acc} ${className}` : acc), '')
}

export const RenderIf = (isTrue, children) => {
  return isTrue ? children : null
}

export const stringToOpts = (dataset) => dataset.map((item) => ({ text: item, value: item }))

export const getIJoistFlgWidthValue = (width) => {
  const result = {
    2.08: 2.0625,
    2.3: 2.3125,
  }

  return result[width] ?? width
}

export const getIJoistFlgThicknessLabel = (material) => {
  const result = {
    1.125: '1 1/8"',
    1.25: '1 1/4"',
    1.3125: '1 5/16"',
    1.375: '1 3/8"',
    1.5: '1 1/2"',
    1.75: '1 3/4"',
    2.5: '2 1/2"',
    default: '0"',
  }

  return result[material] ?? result.default
}

export const getIJoistFlgWidthLabel = (width) => {
  const result = {
    1.5: '1 1/2"',
    1.75: '1 3/4"',
    2: '2"',
    2.08: '2 1/16"',
    2.0625: '2 1/16"',
    2.25: '2 1/4"',
    2.3: '2 5/16"',
    2.3125: '2 5/16"',
    2.5: '2 1/2"',
    2.5625: '2 9/16"',
    3.5: '3 1/2"',
  }

  return result[width]
}

export const isCalculationAction = (actionType) => actionType.toLowerCase().endsWith('calculation')

export const toPercentage = (number) => `${parseFloat(number).toFixed(2)}%`

export const saveAppState = (state) => {
  const calcSettings = getSettingsState(state)

  const appState = {
    [GLOBAL_STATE_NAME.SETTINGS]: state[GLOBAL_STATE_NAME.SETTINGS],
    calculation: {
      settings: calcSettings,
    },
  }

  saveValue(APP_STATE_KEY, appState)
}

export const loadAppState = () => {
  const state = loadValue(APP_STATE_KEY)

  if (state) {
    const updatedCalcInputState = {
      settings: state.calculation?.settings,
      jobSettings: {
        ...defaultValues.jobSettings[APPLICATION_TYPES.PERPENDICULAR_TO_WALL][
          state.calculation?.settings?.country ?? COUNTRY.USA
        ],
      },
    }

    return {
      [GLOBAL_STATE_NAME.SETTINGS]: state[GLOBAL_STATE_NAME.SETTINGS],
      calculation: {
        input: updatedCalcInputState,
      },
    }
  } else {
    return {}
  }
}

export const getInputNameByField = (field, applicationType, roofMemberType) => {
  const inputs = {
    topSlope: roofMemberType === ROOF_MEMBER_TYPES.TRUSS ? 'Top Chord Slope/Angle' : 'Slope/Angle',
    bottomSlope: 'Bottom Chord Slope/Angle',
    uplift: 'Uplift',
    download: 'Download',
    f1: 'F1',
    f2: applicationType === APPLICATION_TYPES.PARALLEL_TO_WALL ? 'F2 Toward' : 'F2',
    f2Away: 'F2 Away',
    heel: 'Heel Height',
    wallLength: 'Wall Length',
    studAlignmentOffset: 'Stud Alignment',
  }

  return inputs[field] ?? field
}

const getFastenerLabel = (type, isATR) => {
  const itemObj = OUTPUT_HELPER_DATA.nail.find((item) => item.enum === type)

  if(!itemObj) return 'enum' + type

  return isATR ? (itemObj.labelATR || itemObj.label) : itemObj.label
}

export const displayFastener = (qty, type) =>
  qty && qty > 0 ? `(${qty}) ${getFastenerLabel(type)}` : 'N/A'

export const getAllThreadRobLabel = (qty, type) =>
  qty && qty > 0 ? `(${qty}) ${getFastenerLabel(type, true)}` : 'N/A'

export const lbsToPlf = (lbsValue, wallLength) =>
  wallLength ? Number((lbsValue * 12) / wallLength).toFixed(0) : 0

export const getHeelMaxHeight = (depth, slope) =>
  Number((depth / Math.cos(Math.atan(slope / 12))).toFixed(3))

export const getHeelMinHeight = (depth, flangeThickness, slope) =>
  Number(((depth - flangeThickness) / Math.cos(Math.atan(slope / 12))).toFixed(3))

export const getRoofWidthOptions = (roofMemberType, roofType) =>
  roofWidthOptions[roofMemberType][roofType] ?? roofWidthOptions[roofMemberType].default
